export default __webpack_public_path__ + "static/media/photo--lg--rob.b864e035.jpg";